import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { MobileModalBody } from "./MobileModalBody";
import { MobileModalHeader } from "./MobileModalHeader";
import MobileModal from "./MobileModal";
import DateAge from "../../_helper/utils.js/DateAge";
import { gender } from "./BookSlot";
import "../css/EditPatientDetail.css";
import {
  useCreateItem,
  useUpdateItem,
} from "../../../_helper/actions/mutation/items";
import CustomButton from "../../../common_component/component/CustomButton";
import InputField from "../../../common_component/component/InputField";
import CuDropdown from "../../../common_component/component/CuDropdown";
import CuModal from "../../../common_component/component/CuModal";
import { toast } from "react-toastify";
import CuForm from "../../../common_component/component/CuForm";
import {
  clinicAtom,
  permissionAtom,
} from "../../../_helper/constant/constant-atom";
import { useAtom } from "jotai";
import { ApiEndPoint } from "../../../_helper/constant/api-types";
import { useItemsFilter } from "../../../_helper/actions/app/items";
import { checkPermission } from "../../../roles_and_permissions/_features";
import { useCurrentRole } from "../../../_helper/constant/Permission";

const EditPatientDetail = ({ isOpen, setIsOpen }) => {
  const [familyMemberOptions, setFamilyMemberOptions] = useState([]);
  const [clinic_idAtom] = useAtom(clinicAtom);
  const [formData, setFormData] = useState({
    phone: "",
    full_name: "",
    age: "",
    dob: "",
    gender: "",
    injuryNumber: "",
    ipdNumber: "",
    opdNumber: "",
  });
  const [isEdit, setIsEdit] = useState(true);
  const [permission] = useAtom(permissionAtom);
  const closeModal = () => setIsOpen({ data: null, flag: false });
  const sm = !useMediaQuery({ query: "(min-width:1024px)" });
  const { role_id } = useCurrentRole();

  const updateMutation = useUpdateItem(
    ApiEndPoint?.QM_SC_SLOTS,
    ApiEndPoint?.USERS
  );

  const { data: existingUser } = useItemsFilter(
    ApiEndPoint?.USERS,
    `?action=getSearchPatient&clinic_id=${clinic_idAtom?.id}&frontend=True&family_id=${isOpen?.data?.family_id}`,
    formData?.phone?.length >= 10 ? true : false
  );

  const { data: customFields } = useItemsFilter(
    "clinics/custom_fields_value/",
    `?action=getCustomFields&clinic_id=${clinic_idAtom?.id}&backend=True&module_name=book_appointment`,
    clinic_idAtom?.id ? true : false
  );

  const validateForm = () => {
    const fullName = formData?.full_name?.split(" ");
    if (fullName?.length > 1) {
      if (fullName[0].length === 0 || fullName[1].length === 0) {
        toast.warning("Please enter last name");
        return false;
      }
    } else {
      toast.warning("Please enter last name");
      return false;
    }

    if (formData?.full_name.length > 50) {
      toast.error("Name is too long");
      return false;
    }
    return true;
  };

  const handleChange = (value, label) => {
    if (label === "dateAge") {
      setFormData((prev) => ({ ...prev, ...value }));
      return;
    }
    if (label === "id") {
      const selectedUser = existingUser?.find((user) => user?.id === value);
      const { full_name, phone, gender, age, dob, id } = selectedUser;
      setFormData({ full_name, phone, gender, age, dob, id });
      setIsEdit(true);
      return;
    }
    setFormData((prev) => ({ ...prev, [label]: value }));
  };

  const createOPDMutation = useCreateItem(ApiEndPoint.QP_CM_CONSULTATION_DATA);

  const postOpdNumber = (slot_id, userId) => {
    if (formData?.opdNumber?.length > 0) {
      const payload = {
        action: "postConsultationData",
        transaction_type: "OPD",
        frontend: "True",
        clinic_id: clinic_idAtom?.id,
        doctor_user: role_id,
        opd_number: formData?.opdNumber,
        personal_details: userId,
        slot_id: slot_id,
        feature_name: "consultation",
      };

      createOPDMutation.mutate(payload, {
        onSuccess: (data) => {},
        onError: () => {},
      });
    }

    return;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const isValidate = validateForm();
    if (isValidate) {
      const payload = {
        id: isOpen?.slotId,
        action: "patchSlots",
        user_details: {
          ...formData,
        },
        frontend: "True",
        clinic_id: clinic_idAtom?.id,
        custom_field_1: {
          custom_field: customFields[0]?.id,
          id: isOpen?.custom_field_1?.id,
          name: customFields[0]?.name,
          display_name: customFields[0]?.display_name,
          value: formData?.injuryNumber,
          offset: "offset",
        },
        ipd_data: {
          id: isOpen?.ipd?.id,
          ipd_number: formData?.ipdNumber,
          clinic_id: clinic_idAtom?.id,
          user_details: formData?.id,
        },
      };

      if (customFields?.length === 0 || !formData?.injuryNumber) {
        delete payload.custom_field_1;
      }

      if (!formData?.ipdNumber) {
        delete payload.ipd_data;
      }

      updateMutation.mutate(
        { data: payload },
        {
          onSuccess: (response) => {
            toast.success("slot edited successfully");
            closeModal();
          },
          onError: () => {
            toast.error("something went wrong! please try again");
          },
        }
      );
    }
  };

  useEffect(() => {
    if (isOpen?.flag && isOpen?.data) {
      let { full_name, phone, gender, age, dob, id } = isOpen?.data;
      setFormData({
        full_name,
        phone,
        gender,
        age,
        dob,
        id,
        injuryNumber: isOpen?.custom_field_1?.value,
        ipdNumber: isOpen?.ipd?.ipd_number,
        opdNumber: isOpen?.opd?.opd_number,
      });
      setFamilyMemberOptions([{ key: id, value: id, text: full_name }]);
    }
  }, [isOpen]);

  useEffect(() => {
    if (existingUser) {
      const options = existingUser?.map((user) => ({
        key: user?.id,
        value: user?.id,
        text: user?.full_name,
      }));
      setFamilyMemberOptions(options || []);
    }
  }, [existingUser]);

  const onAddMember = (value, label) => {
    setFormData((prev) => ({
      phone: prev?.phone,
      gender: "",
      age: "",
      dob: "",
      full_name: value,
      family_id: prev?.phone,
      is_parent: false,
    }));
    setFamilyMemberOptions((prev) => [
      ...prev,
      {
        key: value,
        value: value,
        text: value,
      },
    ]);
  };

  return (
    <div>
      {sm ? (
        <MobileModal
          isOpen={isOpen?.flag}
          closeModal={closeModal}
          modalClassName="modal-container-edit"
          event={"hey"}
        >
          <MobileModalHeader>
            <h4
              className="font-normal lg:text-lg xl:text-xl xlarge:text-2xl"
              style={{ margin: "10px auto 5px" }}
            >
              Edit Patient Detail
            </h4>
          </MobileModalHeader>
          <MobileModalBody>
            <CuForm onSubmit={handleSubmit}>
              <div className="bookslot-firstrow p-2">
                <InputField
                  label={"Phone number"}
                  value={formData?.phone}
                  required
                  disabled
                  onChange={(e) => handleChange(e.target.value, "phone")}
                />
              </div>
              <div className="bookslot-firstrow p-2">
                {familyMemberOptions?.length > 1 && !isEdit && (
                  <>
                    <label className="custom-input-field-label lg:text-sm xl:text-base xlarge:text-xl">
                      Full Name
                    </label>
                    <CuDropdown
                      options={
                        formData?.phone?.length !== 10
                          ? []
                          : familyMemberOptions
                      }
                      value={formData?.id || formData?.full_name}
                      onChange={(val) => handleChange(val, "id")}
                      searchable
                      allowAdditions
                      onAddItem={(val) => onAddMember(val, "full_name")}
                      capitalFirstLetter
                      required
                    />
                  </>
                )}
                {(familyMemberOptions?.length === 1 || isEdit) && (
                  <InputField
                    label={"Full Name"}
                    type={"text"}
                    value={formData?.full_name}
                    required
                    onChange={(e) => handleChange(e.target.value, "full_name")}
                    isEdit={isEdit}
                    setIsEdit={setIsEdit}
                  />
                )}
              </div>
              <div className="bookslot-firstrow p-2">
                <DateAge
                  value={{
                    age: formData?.age,
                    dob: formData?.dob,
                  }}
                  onChange={(val) => handleChange(val, "dateAge")}
                />
              </div>
              <div className="bookslot-firstrow p-2">
                <label className="lg:text-sm xl:text-base xlarge:text-xl">
                  Gender
                </label>
                <div className="cu-editpatient-gender">
                  {gender.map((gen) => (
                    <div key={gen.id} className="cu-editpatient-genderbtns">
                      <input
                        type="radio"
                        checked={formData?.gender === gen.label}
                        onChange={() => handleChange(gen.label, "gender")}
                      />
                      <label className="lg:text-sm xl:text-base xlarge:text-xl">
                        {gen.label}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
              {checkPermission(permission?.allowed_features, 1001) &&
                customFields?.map((cfield) => {
                  return (
                    <div className="p-2">
                      <InputField
                        label={cfield?.display_name}
                        type={cfield?.type}
                        value={formData?.injuryNumber}
                        onChange={(e) =>
                          handleChange(e.target.value, "injuryNumber")
                        }
                      />
                    </div>
                  );
                })}
              {checkPermission(permission?.allowed_features, 1002) && (
                <div className="p-2">
                  <InputField
                    label={"IPD Number"}
                    type={"text"}
                    value={formData?.ipdNumber}
                    onChange={(e) => handleChange(e.target.value, "ipdNumber")}
                  />
                </div>
              )}
              {(checkPermission(permission?.allowed_features, 1002) ||
                checkPermission(permission?.allowed_features, 1003)) && (
                <div className="pl-2 text-[red] text-[12px]">
                  Note :- if you want to edit the OPD no so,please decline the
                  slot and create the slot with the OPD no.
                </div>
              )}

              <div className="btn-center mt-4">
                <CustomButton
                  color={"rgba(199, 234, 201, 1)"}
                  textColor={"rgba(0, 0, 0, 1)"}
                  className="btn-mobile w-[90%] lg:h-11 xl:h-12"
                  type="submit"
                  loading={updateMutation.isLoading}
                >
                  <span className="lg:text-base xl:text-lg xlarge:text-xl">
                    Save
                  </span>
                </CustomButton>
              </div>
            </CuForm>
          </MobileModalBody>
        </MobileModal>
      ) : (
        <>
          <CuModal closeModal={closeModal}>
            <CuForm onSubmit={handleSubmit}>
              <div className="flex justify-between px-2">
                <h3 className="font-normal lg:text-lg xl:text-xl xlarge:text-2xl">
                  Edit patient detail
                </h3>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-6 h-6 cursor-pointer"
                  onClick={closeModal}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M6 18 18 6M6 6l12 12"
                  />
                </svg>
              </div>
              <div className="bookslot-firstrow p-3">
                <InputField
                  label={"Phone number"}
                  value={formData?.phone}
                  required
                  disabled
                  onChange={(e) => handleChange(e.target.value, "phone")}
                />
              </div>
              <div className="bookslot-firstrow p-3">
                {familyMemberOptions?.length > 1 && !isEdit && (
                  <>
                    <label className="custom-input-field-label lg:text-sm xl:text-base xlarge:text-xl">
                      {"Full name"}
                    </label>
                    <CuDropdown
                      options={
                        formData?.phone?.length !== 10
                          ? []
                          : familyMemberOptions
                      }
                      value={formData?.id || formData?.full_name}
                      onChange={(val) => handleChange(val, "id")}
                      searchable
                      allowAdditions
                      onAddItem={(val) => onAddMember(val, "full_name")}
                      capitalFirstLetter
                      required
                    />
                  </>
                )}
                {(familyMemberOptions?.length === 1 || isEdit) && (
                  <InputField
                    label={"Full Name"}
                    type={"text"}
                    value={formData?.full_name}
                    required
                    onChange={(e) => handleChange(e.target.value, "full_name")}
                    isEdit={isEdit}
                    setIsEdit={setIsEdit}
                  />
                )}
              </div>
              <div className="bookslot-firstrow p-3">
                <DateAge
                  value={{
                    age: formData?.age,
                    dob: formData?.dob,
                  }}
                  onChange={(val) => handleChange(val, "dateAge")}
                />
              </div>
              <div className="bookslot-firstrow p-3">
                <label className="lg:text-sm xl:text-base xlarge:text-xl">
                  Gender
                </label>
                <div className="cu-editpatient-gender">
                  {gender.map((gen) => (
                    <div key={gen.id} className="cu-editpatient-genderbtns">
                      <input
                        type="radio"
                        checked={formData?.gender === gen.label}
                        onChange={() => handleChange(gen.label, "gender")}
                      />
                      <label className="lg:text-sm xl:text-base xlarge:text-xl">
                        {gen.label}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
              {checkPermission(permission?.allowed_features, 1001) &&
                customFields?.map((cfield) => {
                  return (
                    <div className="p-2">
                      <InputField
                        label={cfield?.display_name}
                        type={cfield?.type}
                        value={formData?.injuryNumber}
                        onChange={(e) =>
                          handleChange(e.target.value, "injuryNumber")
                        }
                      />
                    </div>
                  );
                })}
              {checkPermission(permission?.allowed_features, 1002) && (
                <div className="p-2">
                  <InputField
                    label={"IPD Number"}
                    type={"text"}
                    value={formData?.ipdNumber}
                    onChange={(e) => handleChange(e.target.value, "ipdNumber")}
                  />
                </div>
              )}
              {(checkPermission(permission?.allowed_features, 1002) ||
                checkPermission(permission?.allowed_features, 1003)) && (
                <div className="pl-2 text-[red] w-[370px] text-[12px]">
                  Note :- if you want to edit the OPD no so,please decline the
                  slot and create the slot with the OPD no.
                </div>
              )}

              <div className="btn-center mt-4">
                <CustomButton
                  color={"rgba(199, 234, 201, 1)"}
                  textColor={"rgba(0, 0, 0, 1)"}
                  className="btn-mobile w-[90%] lg:h-11 xl:h-12"
                  type="submit"
                  loading={updateMutation.isLoading}
                >
                  <span className="lg:text-base xl:text-lg xlarge:text-xl">
                    Save
                  </span>
                </CustomButton>
              </div>
            </CuForm>
          </CuModal>
        </>
      )}
    </div>
  );
};

export default EditPatientDetail;
